import { render, staticRenderFns } from "./unitManagement.vue?vue&type=template&id=3696a1be&scoped=true"
import script from "./unitManagement.vue?vue&type=script&lang=js"
export * from "./unitManagement.vue?vue&type=script&lang=js"
import style0 from "./unitManagement.vue?vue&type=style&index=0&id=3696a1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3696a1be",
  null
  
)

export default component.exports